import { Services } from '../../types/services';

interface State {
  reasons: unknown[];
}

const initialState: State = {
  reasons: [],
};

interface Action {
  type: string;
  payload?: unknown;
}

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    default:
      return state;
  }
};

export const actions = (services: Services) => {
  const axiosCall = services.axios.Axios();

  const fetchMuteReasons = () => {
    return async () => {
      try {
        const response = await axiosCall.get('/muteReasons');
        return (response as unknown as { data: unknown }).data;
      } catch (error) {
        console.error(error);
      }
    };
  };

  return {
    fetchMuteReasons,
  };
};
